import './tooltip.css';
export var tooltipAnimationWrapperCSS = '_hplwyr2-3-5-0';
export var tooltipElementCSS = '_hplwyr1-3-5-0';
export var tooltipOffsetVar = 'var(--_hplwyr0-3-5-0)';